import { useContext, useEffect, useState } from 'react';
import { DataOwnerRequestContext } from '../../../../Common/DataOwnerModels/DataOwnerRequestDetails';
import * as React from 'react';
import * as styled from '.././DataOwnerManagement.styled';
import { CDMRecord, IngestionMethod } from '../../../../Common/DataOwnerModels/CDMRecord';
import { EgressOptionEnum } from '../../../../Common/CommonModels/EgressOptionEnum';
import {
  DependentEntity,
  Rule,
  RuleSetRecord,
  RuleSetTypeComplex,
  RuleSetTypeSingle,
} from '../../../../Common/DataOwnerModels/RuleSetRecord';
import { MessageBar, MessageBarType } from '@fluentui/react';
import * as Constants from '../../../../Common/CommonModels/Constants';
import { goldDomainError, useGetGoldDomains } from '../../../../Hooks/DataOwner/useGetGoldDomains';

interface ReviewStepProps {
  onSubmitErrorFlg: boolean;
  setOnSubmitErrorFlg(val: boolean): void;
}
export function ReviewStep(props: ReviewStepProps): React.ReactElement {
  // Data Owner Request Context
  const {dataOwnerRequestDetails} = useContext(DataOwnerRequestContext);
  const request = dataOwnerRequestDetails.request;
  const [goldDomains, isGoldDomainsLoading, goldDomainsError] = useGetGoldDomains(request?.environment);
  const existingCDMList = dataOwnerRequestDetails.nonProdApprovedCdms.concat(
    dataOwnerRequestDetails.prodApprovedCdms,
    dataOwnerRequestDetails.cdms
  );

  // Form Data
  const [reqDetailsErrorMsg, setReqDetailsErrorMsg] = useState<JSX.Element[]>();
  const [isReqDetailsError, setIsReqDetailsError] = useState<boolean>(false);
  const [cdmDetailsErrorMsg, setCdmDetailsErrorMsg] = useState<JSX.Element[]>();
  const [isCdmDetailsError, setIsCdmDetailsError] = useState<boolean>(false);
  const [ruleSetDetailsErrorMsg, setRuleSetDetailsErrorMsg] = useState<JSX.Element[]>();
  const [isRuleSetDetailsError, setIsRuleSetDetailsError] = useState<boolean>(false);

  const retrieveEgressOptions = (egressOptions: number[]): string => {
    let egressOptionStr = '';
    egressOptions.forEach((x) => (egressOptionStr += EgressOptionEnum[x] + '; '));
    return egressOptionStr;
  };

  useEffect(() => {
        const tempReqDetailsErrorMsg: JSX.Element[] = [];
    let tempIsReqDetailsError = false;
    tempReqDetailsErrorMsg.push(
      <div>
        In <b>Request Details</b> section,
      </div>
    );
    if (dataOwnerRequestDetails?.request?.name == null || dataOwnerRequestDetails?.request?.name.trim().length === 0) {
      tempReqDetailsErrorMsg.push(
        <li>
          <i>Name</i> is required field.
        </li>
      );
      tempIsReqDetailsError = true;
    }
    if (
      dataOwnerRequestDetails?.request?.environment == Constants.Request.ProductionEnvironment &&
      dataOwnerRequestDetails?.request?.privacyApprovalArtifacts?.length <= 0 &&
      dataOwnerRequestDetails?.attachmentList?.length <= 0
    ) {
      tempReqDetailsErrorMsg.push(
        <li>
          Atleast one <i> PrivacyApprovalArtifacts</i> should be provided.
        </li>
      );
      tempIsReqDetailsError = true;
    }

    let tempIsCdmDetailsError = false;
    let tempCdmDetailsErrorMsg: JSX.Element[] = [];
    tempCdmDetailsErrorMsg.push(
      <div>
        In <b>Entities Details</b> section,
      </div>
    );
    if (dataOwnerRequestDetails?.cdms?.length > 0) {
      dataOwnerRequestDetails?.cdms.forEach((cdm, cdmIndex) => {
        const currentErrorMsg: JSX.Element[] = [];
        let currentErrorFlag = false;
        currentErrorMsg.push(
          <>
            For the CDM {cdmIndex + 1} : {cdm.name}
          </>
        );
        if (cdm.name == null || cdm.name.trim().length === 0) {
          currentErrorMsg.push(
            <li>
              <i>CDM Name</i> is required field.
            </li>
          );
          currentErrorFlag = true;
        }
        if (cdm.schema == null || cdm.schema.trim().length === 0) {
          currentErrorMsg.push(
            <li>
              <i>Schema</i> is required field.
            </li>
          );
          currentErrorFlag = true;
        } else{
          if (cdm.schemaErrorText?.trim().length > 0){
            currentErrorMsg.push(
            <li>
              {cdm.schemaErrorText}
            </li>
          );
          currentErrorFlag = true;
          } else{
            currentErrorFlag = false
          }
        }
        if (cdm.egressOptions?.length <= 0) {
          currentErrorMsg.push(
            <li>
              Atleast one <i>Egress option</i> should be selected.
            </li>
          );
          currentErrorFlag = true;
        }
        if (cdm.ingestionType == null || cdm.ingestionType.trim().length === 0) {
          currentErrorMsg.push(
            <li>
              <i>Ingestion type</i> is required field. Default value is "Standard".
            </li>
          );
          currentErrorFlag = true;
        }
        console.log("cdm name error",cdm.cdmNameError )
        if (cdm.cdmNameError?.trim().length > 0){
            currentErrorMsg.push(
            <li>
              {cdm.cdmNameError}
            </li>
          );
          currentErrorFlag = true;
        }
        if (cdm.ingestionType == Constants.CDM.IngestionType_Bulk) {
          if (!Object.values(IngestionMethod).includes(cdm.ingestionOptions?.ingestionMethod as typeof IngestionMethod[keyof typeof IngestionMethod])) {
            currentErrorMsg.push(
              <li>
                <i>Ingestion Method</i> should be selected (Pull, Push or Shortcut).
              </li>
            );
            currentErrorFlag = true;
          }
          if (cdm.ingestionOptions.basePath == null || cdm.ingestionOptions.basePath.trim().length === 0) {
            currentErrorMsg.push(
              <li>
                <i>Base Path</i> is required field.
              </li>
            );
            currentErrorFlag = true;
          }
          if (cdm.ingestionOptions.fileType == null || cdm.ingestionOptions.fileType.trim().length === 0) {
            currentErrorMsg.push(
              <li>
                <i>File Type</i> should be selected.
              </li>
            );
            currentErrorFlag = true;
          }
          if (cdm.ingestionOptions.fileName == null || cdm.ingestionOptions.fileName.trim().length === 0) {
            currentErrorMsg.push(
              <li>
                <i>File Name</i> is required field.
              </li>
            );
            currentErrorFlag = true;
          }
          if (cdm.ingestionOptions.handshakeType == null || cdm.ingestionOptions.handshakeType.trim().length === 0) {
            currentErrorMsg.push(
              <li>
                <i>Handshake Type</i> should be selected.
              </li>
            );
            currentErrorFlag = true;
          }
          if (
            cdm.ingestionOptions.handshakeType == Constants.CDM.HandshakeType_Default &&
            (cdm.ingestionOptions.defaultHandshakeFilePath == null ||
              cdm.ingestionOptions.defaultHandshakeFilePath.trim().length === 0)
          ) {
            currentErrorMsg.push(
              <li>
                <i>Default Handshake File Path</i> is required when Handshake type is selected as 'Default'.
              </li>
            );
            currentErrorFlag = true;
          }
          if (
            cdm.ingestionOptions.ingressFrequency == null ||
            cdm.ingestionOptions.ingressFrequency.trim().length === 0
          ) {
            currentErrorMsg.push(
              <li>
                <i>Ingress Frequency</i> should be selected.
              </li>
            );
            currentErrorFlag = true;
          }
        }
        const domainError = goldDomainError(cdm.domain, goldDomains, isGoldDomainsLoading, goldDomainsError);
        if (domainError) {
          currentErrorMsg.push(<li>Gold routing: {domainError}</li>);
          currentErrorFlag = true;
        }
        if (!['dbo', 'analytical', 'snapshot'].includes(cdm.targetSchema || '')) {
          currentErrorMsg.push(
            <li>Gold routing requires an explicit target schema: dbo, analytical or snapshot.</li>
          );
          currentErrorFlag = true;
        }
        if (currentErrorFlag) {
          tempCdmDetailsErrorMsg = tempCdmDetailsErrorMsg.concat(currentErrorMsg);
          tempIsCdmDetailsError = true;
        }
      });
    }

    let tempIsRulesetDetailsError = false;
    let tempRuleSetDetailsErrorMsg: JSX.Element[] = [];
    tempRuleSetDetailsErrorMsg.push(
      <div>
        In <b>Rule Set Details</b> section,
      </div>
    );
    dataOwnerRequestDetails?.ruleSets.forEach((ruleset, rulesetIndex) => {
      const currentRuleSetErrorMsg: JSX.Element[] = [];
      let currentRuleSetErrorFlag = false;
      currentRuleSetErrorMsg.push(
        <p>
          For the Rule set {rulesetIndex + 1} : {ruleset.name}
        </p>
      );
      if (ruleset.name == null || ruleset.name.trim().length === 0) {
        currentRuleSetErrorMsg.push(
          <li>
            <i>Rule set Name</i> is required field.
          </li>
        );
        currentRuleSetErrorFlag = true;
      }
      if (ruleset?.dataSource?.entityTypeId == null || ruleset?.dataSource?.entityTypeId == '') {
        currentRuleSetErrorMsg.push(
          <li>
            <i>Source CDM</i> should be selected while creating ruleset.
          </li>
        );
        currentRuleSetErrorFlag = true;
      }
      ruleset.dataSource?.dependentEntities?.map((dependentCdm) => {
        if (dependentCdm?.entityTypeId == null || dependentCdm?.entityTypeId.trim().length === 0) {
          currentRuleSetErrorMsg.push(
            <li>
              <i>Dependent CDM</i> should be selected or consider deleting it.
            </li>
          );
          currentRuleSetErrorFlag = true;
        }
        if (ruleset.ruleSetType == RuleSetTypeComplex) {
          if (dependentCdm?.selectExpressions?.length < 0) {
            currentRuleSetErrorMsg.push(
              <li>
                <i>Select Expressions</i> should be configured for Complex Rule Set types.
              </li>
            );
            currentRuleSetErrorFlag = true;
          }
          if (dependentCdm?.joinType == null || dependentCdm?.joinType.trim().length === 0) {
            currentRuleSetErrorMsg.push(
              <li>
                <i>Join Type</i> should be configured for Complex Rule Set types.
              </li>
            );
            currentRuleSetErrorFlag = true;
          }
          if (dependentCdm?.onColumnExpression == null || dependentCdm?.onColumnExpression.trim().length === 0) {
            currentRuleSetErrorMsg.push(
              <li>
                <i>Join Expression</i> should be configured for Complex Rule Set types.
              </li>
            );
            currentRuleSetErrorFlag = true;
          }
        }
      });
      ruleset.rules?.forEach((rule, ruleIndex) => {
        const currentRuleErrMsg: JSX.Element[] = [];
        let currentRuleErrFlg = false;
        currentRuleErrMsg.push(
          <>
            For the Rule {ruleIndex + 1} : {rule.ruleName}
          </>
        );
        if (rule.ruleName == null || rule.ruleName.trim().length === 0) {
          currentRuleErrMsg.push(
            <li>
              <i>Rule Name</i> is required field.
            </li>
          );
          currentRuleErrFlg = true;
        }
        if (rule.expression == null || rule.expression?.compiledExpression == null) {
          currentRuleErrMsg.push(
            <li>
              <i>Expression</i> should be configured for defined rule.
            </li>
          );
          currentRuleErrFlg = true;
        }
        if (
          ruleset.ruleSetType == RuleSetTypeSingle &&
          (rule.expression?.compiledExpression?.cSharp == null ||
            rule.expression?.compiledExpression?.cSharp.trim().length == 0)
        ) {
          tempIsRulesetDetailsError = true;
          currentRuleErrMsg.push(
            <li>
              <i>Expression</i> should be configured for defined rule in C#.
            </li>
          );
        } else if (
          ruleset.ruleSetType == RuleSetTypeComplex &&
          (rule.expression?.compiledExpression?.python == null ||
            rule.expression?.compiledExpression?.python.trim().length == 0)
        ) {
          currentRuleErrFlg = true;
          currentRuleErrMsg.push(
            <li>
              <i>Expression</i> should be configured for defined rule in Python.
            </li>
          );
        }
        if (currentRuleErrFlg) {
          tempRuleSetDetailsErrorMsg = tempRuleSetDetailsErrorMsg.concat(currentRuleErrMsg);
          tempIsRulesetDetailsError = true;
        }
      });
      if (currentRuleSetErrorFlag) {
        tempRuleSetDetailsErrorMsg = tempRuleSetDetailsErrorMsg.concat(currentRuleSetErrorMsg);
        tempIsRulesetDetailsError = true;
      }
    });

    if (tempIsReqDetailsError || tempIsCdmDetailsError || tempIsRulesetDetailsError) {
      props.setOnSubmitErrorFlg(true);
    } else {
      props.setOnSubmitErrorFlg(false);
    }

    setIsReqDetailsError(tempIsReqDetailsError);
    setIsCdmDetailsError(tempIsCdmDetailsError);
    setIsRuleSetDetailsError(tempIsRulesetDetailsError);

    setReqDetailsErrorMsg(tempReqDetailsErrorMsg);
    setCdmDetailsErrorMsg(tempCdmDetailsErrorMsg);
    setRuleSetDetailsErrorMsg(tempRuleSetDetailsErrorMsg);
  }, [dataOwnerRequestDetails, props, goldDomains, isGoldDomainsLoading, goldDomainsError]);

  return (
    <>
      <styled.ReviewRequestContainer>
        <styled.SubSectionalHeading>Request Details</styled.SubSectionalHeading>
        <styled.SectionalDividerDiv>
          <styled.LineDivider />
        </styled.SectionalDividerDiv>
        {(isReqDetailsError || isCdmDetailsError || isRuleSetDetailsError) && (
          <>
            <MessageBar data-testid="message-bar-on-submit-error" messageBarType={MessageBarType.blocked} role="alert">
              Please correct the validation errors before Submitting request. You may Save request as Draft.
            </MessageBar>
            {isReqDetailsError && (
              <MessageBar messageBarType={MessageBarType.error} role="alert">
                {reqDetailsErrorMsg}
              </MessageBar>
            )}
            {isCdmDetailsError && (
              <MessageBar messageBarType={MessageBarType.error} role="alert">
                {cdmDetailsErrorMsg}
              </MessageBar>
            )}
            {isRuleSetDetailsError && (
              <MessageBar messageBarType={MessageBarType.error} role="alert">
                {ruleSetDetailsErrorMsg}
              </MessageBar>
            )}
          </>
        )}
        <styled.RequestReviewTable>
          <tr>
            <th>Environment</th>
            <td>{request.environment === 0 ? 'Non-Production' : 'Production'}</td>
          </tr>
          <tr>
            <th>Request Name</th>
            <td>{request.name}</td>
          </tr>
          <tr>
            <th>Description</th>
            <td>{request.description}</td>
          </tr>
          <tr>
            <th>Privacy Approval Date</th>
            <td>{request.privacyApprovalDate}</td>
          </tr>
          <tr>
            <th>Additional Notes</th>
            <td>{request.additionalNotes}</td>
          </tr>
          <br />
        </styled.RequestReviewTable>
        <styled.SubSectionalHeading>CDMs</styled.SubSectionalHeading>
        <styled.SectionalDividerDiv>
          <styled.LineDivider />
        </styled.SectionalDividerDiv>

        {dataOwnerRequestDetails?.cdms?.length <= 0 && (
          <styled.ReviewTable>
            <tr>
              <td colSpan={2}> No CDMs are defined </td>
            </tr>
            <br />
          </styled.ReviewTable>
        )}
        {dataOwnerRequestDetails?.cdms?.map((cdmObj: CDMRecord, cdmIndex) => (
          <>
            <styled.ReviewTable>
              <tr>
                <td style={{ width: '5%' }}>{cdmIndex + 1 + '.'}</td>
                <th>CDM Name</th>
                <td>{cdmObj.name}</td>
              </tr>
              <tr>
                <td style={{ width: '5%' }}></td>
                <th>Description</th>
                <td>{cdmObj.description}</td>
              </tr>
              <tr>
                <td style={{ width: '5%' }}></td>
                <th>Egress Options</th>
                <td>{retrieveEgressOptions(cdmObj.egressOptions)}</td>
              </tr>
              <tr>
                <td style={{ width: '5%' }}></td>
                <th>Gold routing</th>
                <td>{cdmObj.domain || 'Not selected'} / {cdmObj.targetSchema || 'Not selected'}</td>
              </tr>
            </styled.ReviewTable>
            <br />
          </>
        ))}
        <styled.SubSectionalHeading>Rule Sets</styled.SubSectionalHeading>
        <styled.SectionalDividerDiv>
          <styled.LineDivider />
        </styled.SectionalDividerDiv>
        {dataOwnerRequestDetails?.ruleSets?.length <= 0 && (
          <styled.ReviewTable>
            <tr>
              <td colSpan={2}> No Rule Sets are defined </td>
            </tr>
            <br />
          </styled.ReviewTable>
        )}
        {dataOwnerRequestDetails?.ruleSets?.map((ruleSetObj: RuleSetRecord, ruleSetIndex) => (
          <>
            <styled.ReviewTable>
              <tr>
                <td style={{ width: '5%' }}>{ruleSetIndex + 1 + '.'}</td>
                <th>Rule Set Name</th>
                <td>{ruleSetObj.name}</td>
              </tr>
              <tr>
                <td style={{ width: '5%' }}></td>
                <th>Rule Set Type</th>
                <td>{ruleSetObj.ruleSetType}</td>
              </tr>
              <tr>
                <td style={{ width: '5%' }}></td>
                <th>Source CDM</th>
                <td>{existingCDMList?.find((x) => x.id == ruleSetObj?.dataSource?.entityTypeId)?.name}</td>
              </tr>
              <tr>
                <td style={{ width: '5%' }}></td>
                <th>Dependent CDMs</th>
                <td>
                  {ruleSetObj?.dataSource?.dependentEntities?.map(
                    (depCdm: DependentEntity) =>
                      existingCDMList?.find((x) => x.id == depCdm?.entityTypeId)?.name + '; \n'
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ width: '5%' }}></td>
                <th>Rules</th>
                <td>{ruleSetObj?.rules?.map((ruleObj: Rule) => ruleObj?.ruleName + '; \n')}</td>
              </tr>
            </styled.ReviewTable>
            <br />
          </>
        ))}
      </styled.ReviewRequestContainer>
    </>
  );
}
